export enum ActionType {
  ADD_FEEDBACK = 'ADD_FEEDBACK',
  ADD_FEEDBACK_FULFILLED = 'ADD_FEEDBACK_FULFILLED',
  ADD_FEEDBACK_REJECTED = 'ADD_FEEDBACK_REJECTED',
}

export default ActionType;
